import { j as E } from "./jsx-runtime-3tyXYecC.mjs";
import { forwardRef as H } from "react";
import { f as M } from "./index-LyFokDcn.mjs";
import { m as A } from "./tss-DN0acMKN.mjs";
import { M as G, d as R } from "./constants-CnFYFetN.mjs";
import { I as F } from "./icon-v2-DGtVEk7e.mjs";
import { B as O } from "./Box-B5hjovXR.mjs";
var e = /* @__PURE__ */ ((a) => (a.Brand = "Brand", a.Discovery = "Discovery", a.Error = "Error", a.Greenhouse = "Greenhouse", a.Inactive = "Inactive", a.Info = "Info", a.Inverted = "Inverted", a.Neutral = "Neutral", a.Warning = "Warning", a.Success = "Success", a))(e || {});
const V = A()(({ palette: a, spacing: W, typography: g, borderRadiuses: l, constructs: r, mode: C }, { muted: f, type: n }) => {
  var y, j;
  const b = (o) => {
    const i = {
      [e.Brand]: a.primary.main,
      [e.Discovery]: "#6A4197",
      [e.Error]: a.error.main,
      [e.Greenhouse]: "#6A4197",
      [e.Inactive]: a.gray[700],
      [e.Info]: a.info.main,
      [e.Inverted]: a.common.white,
      [e.Neutral]: a.gray[600],
      [e.Success]: a.success.main,
      [e.Warning]: a.warning.main
    };
    return o ? i[o] : void 0;
  }, z = (o, i) => {
    var d, v, x, m, I, h, k, w, B, S;
    const D = {
      [e.Brand]: (d = r.surface.primary) == null ? void 0 : d[i ? "weak" : "strong"],
      [e.Discovery]: (v = r.surface.discovery) == null ? void 0 : v[i ? "weak" : "strong"],
      [e.Error]: (x = r.surface.error) == null ? void 0 : x[i ? "weak" : "strong"],
      [e.Greenhouse]: (m = r.surface.discovery) == null ? void 0 : m[i ? "weak" : "strong"],
      [e.Inactive]: (I = r.surface.neutral) == null ? void 0 : I[i ? "weak" : "strong"],
      [e.Info]: (h = r.surface.info) == null ? void 0 : h[i ? "weak" : "strong"],
      [e.Inverted]: (k = r.surface.neutral) == null ? void 0 : k.inverted,
      [e.Neutral]: (w = r.surface.neutral) == null ? void 0 : w[i ? "weak" : "strong"],
      [e.Success]: (B = r.surface.success) == null ? void 0 : B[i ? "weak" : "strong"],
      [e.Warning]: (S = r.surface.warning) == null ? void 0 : S[i ? "weak" : "strong"]
    };
    return o ? D[o] : void 0;
  }, N = (o, i) => {
    var d, v, x, m, I, h, k, w, B, S;
    const D = {
      [e.Brand]: (d = r == null ? void 0 : r[i].primary) == null ? void 0 : d.strong,
      [e.Discovery]: (v = r == null ? void 0 : r[i].discovery) == null ? void 0 : v.strong,
      [e.Error]: (x = r == null ? void 0 : r[i].error) == null ? void 0 : x.strong,
      [e.Greenhouse]: (m = r == null ? void 0 : r[i].discovery) == null ? void 0 : m.strong,
      [e.Inactive]: (I = r == null ? void 0 : r[i].neutral) == null ? void 0 : I.strong,
      [e.Info]: (h = r == null ? void 0 : r[i].info) == null ? void 0 : h.strong,
      [e.Inverted]: (k = r == null ? void 0 : r[i].primary) == null ? void 0 : k.strong,
      [e.Neutral]: (w = r == null ? void 0 : r[i].neutral) == null ? void 0 : w.strong,
      [e.Success]: (B = r == null ? void 0 : r[i].success) == null ? void 0 : B.strong,
      [e.Warning]: (S = r == null ? void 0 : r[i].warning) == null ? void 0 : S.strong
    };
    return o ? D[o] : void 0;
  };
  return {
    root: M.ifFeature(
      "encore",
      {
        backgroundColor: C === G.Dye ? R.main : z(n, f),
        borderRadius: l[100],
        color: n === e.Inverted || f ? N(n, "text") : r.text.neutral.inverted,
        display: "inline-block",
        fontSize: (y = g.xsmall) == null ? void 0 : y.fontSize,
        fontWeight: g.fontWeightMedium,
        lineHeight: (j = g.xsmall) == null ? void 0 : j.lineHeight,
        padding: W(0.5, 1)
      },
      {
        backgroundColor: C === G.Dye ? R.main : b(n),
        borderRadius: "4px",
        color: a.primary.contrastText,
        display: "inline-block",
        fontSize: "11px",
        fontWeight: g.fontWeightBold,
        letterSpacing: "0.5px",
        lineHeight: "8px",
        padding: "5px",
        textTransform: "uppercase"
      }
    ),
    icon: {
      fill: n === e.Inverted || f ? N(n, "icon") : r.text.neutral.inverted,
      marginRight: W(0.5),
      position: "relative",
      top: "1px"
    }
  };
}), Y = H(({ children: a, classes: W, className: g, icon: l, muted: r, type: C }, f) => {
  const { classes: n, cx: b } = V({ muted: r, type: C }, { props: { classes: W } });
  return /* @__PURE__ */ E.jsxs(O, { className: b(g, n.root), "data-fabric-component": "Pill", ref: f, children: [
    l != null && l.endsWith("-solid") ? /* @__PURE__ */ E.jsx("span", { className: n.icon, children: /* @__PURE__ */ E.jsx(F, { name: l, size: 12 }) }) : null,
    a
  ] });
});
export {
  Y as P,
  e as a
};
//# sourceMappingURL=pill-DHjByxtv.mjs.map
